module.exports = __webpack_public_path__ + "static/img/light.bb0f9137.svg";